import styles from "./BuildingLoadingEventMobile.module.styl";
import { toDateStringLocale } from "utils";
import { Card } from "uikit/components";
import { number, shape, string } from "prop-types";

export default function BuildingLoadingEventMobile({ eventData }) {
    return (
        <Card borderRadius={"giant"} padding={"none"} className={styles.form} key={eventData.id}>
            <div className={styles.row}>
                <div className={styles.header}>Даты</div>
                <div className={styles.value}>
                    {toDateStringLocale(eventData.dateInterval.start)} -{" "}
                    {toDateStringLocale(eventData.dateInterval.end)}
                </div>
            </div>
            <div className={styles.row}>
                <div className={styles.header}>Название мероприятия</div>
                <div className={styles.boldValue}>{eventData.name}</div>
            </div>
            <div className={styles.row}>
                <div className={styles.value}>
                    {eventData.sportType} - {eventData.eventType}
                </div>
            </div>
            <div className={styles.row}>
                <div className={styles.header}>Статус мероприятия</div>
                <div className={styles.value}>{eventData.eventStatus}</div>
            </div>
            <div className={styles.row}>
                <div className={styles.header}>Место проведения</div>
                <div className={styles.value}>{eventData.locationName}</div>
            </div>
        </Card>
    );
}

BuildingLoadingEventMobile.propTypes = {
    eventData: shape({
        id: number.isRequired,
        name: string.isRequired,
        dateInterval: shape({
            start: string.isRequired,
            end: string.isRequired,
        }).isRequired,
        eventStatus: string.isRequired,
        eventType: string.isRequired,
        sportType: string.isRequired,
        locationName: string.isRequired,
    }),
};
